import { Palette } from "lucide-react";

import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

import {
  GRADE_RESTRICTION_HINT_OFF,
  GRADE_RESTRICTION_HINT_ON,
  GRADE_RESTRICTION_LABEL,
} from "./grade-messages";

const SWITCH_ID = "grade-restriction-switch";
const HINT_ID = "grade-restriction-hint";

interface GradeRestrictionSwitchProps {
  checked: boolean;
  onCheckedChange: (checked: boolean) => void;
  disabled?: boolean;
}

export function GradeRestrictionSwitch({
  checked,
  onCheckedChange,
  disabled = false,
}: GradeRestrictionSwitchProps): JSX.Element {
  const hint: string = checked ? GRADE_RESTRICTION_HINT_ON : GRADE_RESTRICTION_HINT_OFF;

  return (
    <div className="flex items-start gap-3 rounded-lg border bg-card p-3">
      <Palette className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden />
      <div className="min-w-0 flex-1 space-y-1">
        <Label htmlFor={SWITCH_ID} className="cursor-pointer text-sm font-medium">
          {GRADE_RESTRICTION_LABEL}
        </Label>
        <p id={HINT_ID} className="text-xs text-muted-foreground">
          {hint}
        </p>
      </div>
      <Switch
        id={SWITCH_ID}
        checked={checked}
        onCheckedChange={onCheckedChange}
        disabled={disabled}
        aria-describedby={HINT_ID}
      />
    </div>
  );
}
